<div class="modal-header justify-content-end">
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row mb-4">
    <div class="col-sm-12 text-center">

      <div class="btn-group media-btn-group" role="group" aria-label="MediaLibraryNavigation">
        <button type="button" [ngClass]="{'active' : activeMenu === 'upload'}" (click)="changeMenu('upload')" class="btn btn-primary upload">{{ 'UPLOAD_IMAGE' | translate }}</button>
        <button type="button" [ngClass]="{'active' : activeMenu === 'browse'}" (click)="changeMenu('browse')" class="btn btn-primary browse">{{ 'BROWSE_GALLERY' | translate }}</button>
      </div>

    </div>
  </div>

  <app-browse-media [userId]="userId" [hidden]="activeMenu !== 'browse'" (selectMediaEvent)="onSelectMedia($event)"></app-browse-media>
  <app-upload-media [userId]="userId" #uploadMedia [hidden]="activeMenu !== 'upload'" (uploadDoneEvent)="onUploadDone($event)" (selectMediaEvent)="onSelectMedia($event)"></app-upload-media>

</div>
<div class="modal-footer justify-content-center">
  <button type="button" class="btn btn-primary" *ngIf="activeMenu === 'upload'"  [disabled]="!isAllowToUpload()" (click)="startUpload()">{{ 'START UPLOAD' | translate }}</button>
  <button type="button" class="btn btn-default" (click)="activeModal.dismiss('Close click')">{{ 'CLOSE' | translate }}</button>
</div>


// WEBPACK FOOTER //
// ./src/app/media-library/media-library.component.html